import { action } from '../constants/constant.action';
const {
  SET_USER_DETAIL, IS_PROFILE_UPDATE
} = action;

export const setUserDetail = user => {
  return ({
    type: SET_USER_DETAIL,
    user
  })
};

export const isProfileUpdate = isProfileUpdate => {
  return ({
    type: IS_PROFILE_UPDATE,
    isProfileUpdate
  })
};

// export const setUserDetail = user => ({
//   type: SET_USER_DETAIL,
//   user
// });